import { createHOC } from 'vue-hoc';

import LoginForm from './LoginForm';
import auth from '../../../../lib/common/providers/auth';

const options = {
  name: 'LoginFormContainer',
  data() {
    return {
      state: {
        loading: false,
        error: null,
      },
    };
  },
  async created() {
    if (await auth.isAuthenticated()) {
      this.$router.push({ name: 'verifyEmail' });
    }
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
  },
  listeners: {
    async login(email, password) {
      this.state.error = null;
      this.state.loading = true;
      const { query } = this.$route;
      try {
        // short circuit for missing password
        if (!password || !password.length) {
          throw new Error('Must specify a password.');
        }
        const options = {
          email,
          password,
        };
        if (query.redirectUrl) {
          options.redirectUri = `${
            window.location.origin
          }/auth/callback?updated=${Date.now()}&redirectUrl=${
            query.redirectUrl
          }`;
        }
        await auth.login(options);
      } catch (error) {
        console.error(error);
        this.state.error = {
          ...error,
          message: error.message || error.description,
        };
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const LoginFormContainer = createHOC(LoginForm, options, renderWith);
export default LoginFormContainer;
